import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import SectorsSelector from 'components/Shared/Selectors/SectorsSelector';
import { withEditFunctionality } from 'components/Portfolio/PortfolioAbout/components/hoc/withEditFunctionality';
import styles from './IndustryExperience.module.scss';

@withEditFunctionality
export default class IndustryExperience extends PureComponent {
  static propTypes = {
    data: PropTypes.array,
    editMode: PropTypes.bool,
    updateData: PropTypes.func,
    user: PropTypes.any,
  };

  updateSectors = (sectors) => {
    const newSectors = Array.isArray(sectors) ? sectors : [sectors];
    const { updateData: updateSectors } = this.props;
    const sectorsList = newSectors.map((sectors) => sectors.value);
    updateSectors(sectorsList);
  };

  renderSectors = (sectors) =>
    sectors.map((sector) => (
      <li key={sector} className={styles.chip}>
        {sector}
      </li>
    ));

  render() {
    const { data: sectors, editMode, user } = this.props;
    return (
      (sectors.length > 0 || editMode) && (
        <div id="portfolio-sectors">
          {editMode ? (
            <SectorsSelector
              existing={user.sectors}
              onSelect={this.updateSectors}
              multi={user.type === 'seller'}
              style={{ width: '100%' }}
            />
          ) : (
            <ul className={styles.chips}>{this.renderSectors(sectors)}</ul>
          )}
        </div>
      )
    );
  }
}
